import React from 'react'
import { useLanguage } from '../../contexts/LanguageContext'

const PoiExternalLink = ({ poiExternalLink }) => {
  const { activeLanguage } = useLanguage()
  const link = poiExternalLink.externalLink

  const url =
    activeLanguage === 'fr'
      ? link.urlFr
      : activeLanguage === 'en'
      ? link.urlEn
      : link.urlEs

  const label =
    activeLanguage === 'fr'
      ? link.labelFr
      : activeLanguage === 'en'
      ? link.labelEn
      : link.labelEs

  return (
    <div className="external-link-item">
      <span className="label">{label}</span>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="external-url"
      >
        {url}
      </a>
    </div>
  )
}

export default PoiExternalLink
